//------------------------------------
// get visible column index by field
//-----------------------------------
export default function getVisibleColumnIndexByField(headings, field) {
  //----------------
  // return col idx
  //----------------
  let vis_cols = headings.filter((a) => a.hidden == false);
  let col_idx = vis_cols.map((a) => a.field).indexOf(field);
  return col_idx;
}
